<template>
  <div class="flex flex-col h-screen font-roboto">
    <div class="mb-20">
      <slot></slot>
    </div>
    <div class="flex-grow"></div>
    <Footer />
    <CookieBanner />
  </div>

</template>



<style>
</style>
